import _extends from "@babel/runtime/helpers/esm/extends";
import { Button } from '../../Button';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function ActionButtons(_ref) {
  var buttonWidthStyle = _ref.buttonWidthStyle,
    destructive = _ref.destructive,
    onPrimaryButtonClick = _ref.onPrimaryButtonClick,
    onSecondaryButtonClick = _ref.onSecondaryButtonClick,
    primaryButtonProps = _ref.primaryButtonProps,
    primaryButtonText = _ref.primaryButtonText,
    secondaryButtonProps = _ref.secondaryButtonProps,
    secondaryButtonText = _ref.secondaryButtonText;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [(secondaryButtonProps == null ? void 0 : secondaryButtonProps.children) || secondaryButtonText && /*#__PURE__*/_jsx(Button, _extends({
      onClick: onSecondaryButtonClick,
      size: "large",
      sx: {
        width: buttonWidthStyle
      },
      variant: "secondary-gray"
    }, secondaryButtonProps, {
      children: (secondaryButtonProps == null ? void 0 : secondaryButtonProps.children) || secondaryButtonText
    })), (primaryButtonProps == null ? void 0 : primaryButtonProps.children) || primaryButtonText && /*#__PURE__*/_jsx(Button, _extends({
      onClick: onPrimaryButtonClick,
      size: "large",
      sx: {
        width: buttonWidthStyle
      },
      variant: destructive ? 'primary-destructive' : 'primary'
    }, primaryButtonProps, {
      children: (primaryButtonProps == null ? void 0 : primaryButtonProps.children) || primaryButtonText
    }))]
  });
}